import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class AccessResource extends Form {
  static contextType = PopUpContext;
  state = {
    data: {
      name: "",
    },
    errors: {},
  };

  schema = {
    name: Joi.string().max(32).required(),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      await db
        .save("access/resource", __controls)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{lbl.AddResource}</p>
          </div>
          <div className="form-inputs">{this.renderInput("name", "منبع")}</div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default AccessResource;
